import {AiOutlineExclamationCircle} from "react-icons/ai";

export const AddedValuesWarning = () => (
  <div className="d-flex rounded rounded-3 p-2 px-4 border border-black align-items-center gap-4">
    <div>
      <AiOutlineExclamationCircle />
    </div>
    <div className="lh-base">
      We noticed you configured some extra addons. If you do not wish to purchase additional addons right now, simply
      remove them if no longer required or simply proceed to checkout.
    </div>
  </div>
);
